const initialState = {
    messages: [],
};
const messagesReducer = (
    state: any = initialState,
    action: { type: string, payload?: any },
): any => {
    const upsertMessage = (currentMessages: any[], incoming: any) => {
        const nextMessages = [...currentMessages];
        const index = nextMessages.findIndex((item: any) => {
            if (incoming?.id && item?.id) {
                return item.id === incoming.id;
            }
            if (incoming?.client_reference && item?.client_reference) {
                return item.client_reference === incoming.client_reference;
            }
            return false;
        });

        if (index > -1) {
            nextMessages[index] = {
                ...nextMessages[index],
                ...incoming,
            };
        } else {
            nextMessages.push(incoming);
        }

        return nextMessages;
    };

    switch (action.type) {
        case 'MESSAGE_RECEIVED':
            return {
                ...state,
                messages: upsertMessage(state.messages, action.payload),
            };
        case 'ADD_MESSAGE':
            return {
                ...state,
                messages: upsertMessage(state.messages, action.payload),
            };
        case 'CLEAR_CHAT':
            return {
                ...state,
                messages: []
            };
        case 'UPDATE_CHAT':
            return {
                ...state,
                ...action.payload
            };
    }
    return state;
};

export default messagesReducer;
